import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36178409"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container max-w-2xl mx-auto flex flex-col items-center justify-center min-h-full px-6 md:px-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold mb-2" }, "Check your email", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-base text-gray-600 font-medium" }, "We've sent you an email with the link to log in", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-900 font-medium mt-9 mb-2" }, "Didn't receive the email?", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-center font-regular text-gray-600 mb-6" }, " If you haven't received the email after a few minutes, please check your spam or junk folder before requesting a new log in link. ", -1))
const _hoisted_6 = { class: "container" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Request a new log in link ")
const _hoisted_8 = { class: "bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IonButton = _resolveComponent("IonButton")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_IonButton, {
                id: "request-new-link",
                fill: "outline",
                expand: "block",
                onClick: _withModifiers($setup.sendMagicLink, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_ion_icon, {
              id: "bp-logo",
              src: $setup.bigPicture,
              class: "w-full h-20"
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_loading, {
        "is-open": $setup.isLoading,
        message: "Sending email"
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}